import { emailRegex } from "common/utils/data_validations";
import { AppConfiguration } from "config";
import { genericGetRequest } from "./sf_backend_helper";
import { QUOTE_FUNNEL } from "./sf_constants";
import * as CONSTANTS from '../common/utils/data_validations'

export const PLURAL_LABELS = {
    DRIVERS: 'drivers',
    VEHICLES: 'vehicles'
}

export function makeLabelForRepeatableQuestionsForAutoQuoteFunnel(numSeconds, question_label) {
    const ordinals = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th'];
    let singular_label = "";
    if (numSeconds >= 0 && numSeconds <= 10) {
        return (`${ordinals[numSeconds]} ${singular_label} ${question_label}`);
    } else {
        return (`Another ${singular_label} ${question_label}`);
    }
}
export function makeLabelForRepeatableQuestions(numSeconds, question_group_label, question_label) {
    const ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth'];
    let singular_label = "";
    switch (question_group_label) {
        case PLURAL_LABELS.DRIVERS:
            singular_label = "driver";
            break;
        case PLURAL_LABELS.VEHICLES:
            singular_label = "vehicle";
            break;
        default:
            singular_label = question_group_label
            break;
    }
    if (numSeconds >= 0 && numSeconds <= 10) {
        return (`${ordinals[numSeconds]} ${singular_label}: ${question_label}`);
    } else {
        return (`Another ${singular_label}: ${question_label}`);
    }
}

export const validate_email_review = async (quote_funnel_questions_ordered) => {
    const emailQuestion = quote_funnel_questions_ordered.find(item => item.question_type === QUOTE_FUNNEL.COMPONENT_TYPE.EMAIL)
    let isEmailValid = true
    if (emailQuestion?.required || emailQuestion?.value) {
        isEmailValid = await validate_email_request(emailQuestion)
    }
    return [isEmailValid, emailQuestion?.page_index, emailQuestion?.page_group_index]
}

export const validate_phone_review = async (quote_funnel_questions_ordered) => {
    const phoneQuestion = quote_funnel_questions_ordered.find(item => item.question_type === QUOTE_FUNNEL.COMPONENT_TYPE.PHONE_NUMBER)
    let isPhoneNumValid = true
    if (phoneQuestion?.required) {
        isPhoneNumValid = await validate_phone_request(phoneQuestion, phoneQuestion?.value)
    }
    return [isPhoneNumValid, phoneQuestion?.page_index, phoneQuestion?.page_group_index]
}

export const validate_phone_request = async (phoneQuestion, value) => {
    let isPhoneNumValid = (CONSTANTS.phoneRegExp).test(value)
    if (isPhoneNumValid && phoneQuestion?.validation) {
        try {
            const response = await genericGetRequest(`${AppConfiguration.BACKEND_URL}/api/v1/validate_email_phone_number`,
                {
                    validate_type: 'phone_number',
                    phone_number: value
                }, {})
            isPhoneNumValid = response?.validation || false
        } catch (error) { }
    }
    return isPhoneNumValid
}

export const validate_email_request = async (emailQuestion) => {
    let isEmailValid = emailRegex.test(emailQuestion?.value);
    if (isEmailValid && emailQuestion?.validation) {
        try {
            const response = await genericGetRequest(`${AppConfiguration.BACKEND_URL}/api/v1/validate_email_phone_number`,
                {
                    validate_type: 'email',
                    email: emailQuestion?.value
                }, {})
            isEmailValid = response?.validation || false
        } catch (error) { }
    }
    return isEmailValid
}

// ------- QUOTE-FUNNEL-SPLASH-FIELDS-LABEL-MAPPING :START ------
export const quoteFunnelSplashFieldsLabelMapping = [
    { currently_insured: 'Currently Insured' },
    { carrier: 'Carrier' },
    { continuous_insurance: 'Continuous Coverage' },
    { own_home: 'Homeowner' },
    { bundle_home: 'Bundle Home' },
    { military_affiliation: 'Military' },
    { address: 'Address' },
    { address2: 'Unit' },
    { city: 'City' },
    { state: 'State' },
    { zip: 'Zip Code' },
    { email: 'Email' },
    { primary_phone: 'Phone' }
];
// LABEL-MAPPING :START ----
for (let i = 1; i <= 10; i++) {
    const index = i - 1;
    quoteFunnelSplashFieldsLabelMapping.push({
        [`vehicles_year_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Vehicle Year'),
        [`vehicles_make_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Vehicle Make'),
        [`vehicles_model_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Vehicle Model'),
        [`drivers_date_of_birth_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Driver DOB'),
        [`drivers_gender_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Driver Gender'),
        [`drivers_marital_status_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Driver Marital Status'),
        [`drivers_at_fault_accidents_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Driver Accidents'),
        [`drivers_dui_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Driver DUI'),
        [`drivers_first_name_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Driver First Name'),
        [`drivers_last_name_${i}`]: makeLabelForRepeatableQuestionsForAutoQuoteFunnel(index, 'Driver Last Name'),
    });
}
// LABEL-MAPPING :END ----
// ------- QUOTE-FUNNEL-SPLASH-FIELDS-LABEL-MAPPING :END ------
export const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        return;
    }
};
//Function to format phone number e.g. +11234567890 => 1234567890
export const cleanPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    const cleanedPhoneNumber = phoneNumber.replace('+1', '');
    return cleanedPhoneNumber ? cleanedPhoneNumber : phoneNumber;
};

//Function to format phone number e.g. +11234567890 => 123-456-7890
export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    // Remove +1 from the beginning of the phone number
    const cleanedPhoneNumber = phoneNumber.replace('+1', '');
    // Format the phone number
    const formattedPhoneNumber = cleanedPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    return formattedPhoneNumber ? formattedPhoneNumber : cleanedPhoneNumber;
};

export const sort_by_order = (a, b) => {
    return a.order - b.order;
}